import React from 'react';

const Toolbar = ({
  addNode,
  selectedNode,
  renameNode,
  deleteNode,
  selectedEdge,
  removeEdge,
  saveSession,
  clearAll,
  undo,
  history,
  handleOpenFlowClick,
  handleChatButtonClick, // Add this line
  isSending, // Add this line
}) => (
  <div style={{ position: 'absolute', zIndex: 10, top: 10, left: 10 }}>
    <button onClick={addNode} style={{ marginRight: '8px', padding: '8px 12px' }}>
      Add Node
    </button>
    <button
      onClick={() => selectedNode && renameNode(selectedNode.id)}
      style={{ marginRight: '8px', padding: '8px 12px' }}
      disabled={!selectedNode}
    >
      Rename
    </button>
    <button
      onClick={() => selectedNode && deleteNode(selectedNode.id)}
      style={{ padding: '8px 12px' }}
      disabled={!selectedNode}
    >
      Delete
    </button>
    <span style={{ margin: '0 8px' }}>|</span>
    <button
      onClick={() => selectedEdge && removeEdge(selectedEdge.id)}
      style={{ padding: '8px 12px' }}
      disabled={!selectedEdge}
    >
      Remove Edge
    </button>
    <span style={{ margin: '0 8px' }}>|</span>
    <button onClick={saveSession} style={{ marginRight: '8px', padding: '8px 12px' }}>
      Save Backup
    </button>
    <button onClick={clearAll} style={{ marginLeft: '8px', padding: '8px 12px' }}>
      Clear All
    </button>
    <button
      onClick={undo}
      style={{ marginLeft: '8px', padding: '8px 12px' }}
      disabled={history.length === 0}
    >
      Undo
    </button>
    <button onClick={handleOpenFlowClick} style={{ marginLeft: '8px', padding: '8px 12px' }}>
      Open Flow
    </button>
    <button
      className="chat-button" // Add this line
      onClick={handleChatButtonClick}
      disabled={isSending}
    >
      AI Chat
    </button>
  </div>
);

export default Toolbar;